import styled from "styled-components";

export const Line = styled.hr`
    border: none;
    height: 5px;
    fill: black;
    width: 200px;
    border-color: var(--text-primary-color);
    background: var(--text-primary-color);
    border-radius: 5px;
    margin: 10px;
  `